module.exports = __webpack_public_path__ + "img/icon_audition_big.75b9cee5.png";